import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import emlogo from "../../images/em-logo.svg";
import { Link } from "react-router-dom";
import { API_URL, UPLOAD_URL } from "../../api/api";

import { toast } from "sonner";
const ViewSignature = () => {
  const { id } = useParams(); // URL param for signature id
  // const navigate = useNavigate();
  // Module is reachable under /admin and /hr — link within the same base.
  const basePath =
    (localStorage.getItem("role") || "").toLowerCase().trim() === "hr"
      ? "/hr"
      : "/admin";
  const [signature, setSignature] = useState(null);
  const [brand, setBrand] = useState(null);
  const [theme, setTheme] = useState("light");

  useEffect(() => {
    const auth = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };
    const fetchSignature = async () => {
      try {
        const res = await axios.get(`${API_URL}/api/signatures/${id}`, auth);
        setSignature(res.data);
        setTheme(res.data.theme); // initial theme from backend
      } catch (err) {
        console.error(err);
        if (err.response?.status === 401) {
          toast.error("Session expired or unauthorized. Please log in again.");
        }
      }
    };
    // Brand info (logo / website / socials) so the signature stays on-brand.
    const fetchBrand = async () => {
      try {
        const res = await axios.get(`${API_URL}/api/signatures/brand`, auth);
        setBrand(res.data || null);
      } catch {
        setBrand(null);
      }
    };

    fetchSignature();
    fetchBrand();
  }, [id]);
  if (!signature) return <p>Loading...</p>;

  const handleThemeChange = (e) => {
    setTheme(e.target.value);
  };

  return (
    <>
      {/* Aceternity-style pure-CSS dot background — overlay only (see index.css). */}
      <div className="dot-bg" aria-hidden="true" />
      <div className="full-wrap">
        <div className="middle-wrap">
          <div
            className={`signature-wrap ${theme === "black" ? "darkbox" : "lightbox"}`}
          >
            {/* Header with theme selection */}
            <div className="sig-header">
              <h2>Create Signature as</h2>
              <div className="field-item">
                <div className="label">Choose Theme:</div>
                <div className="radio-wrap">
                  <label className="light-card">
                    <input
                      type="radio"
                      name="theme"
                      value="white"
                      checked={theme === "white"}
                      onChange={handleThemeChange}
                    />
                    <i></i>
                  </label>
                  <label className="dark-card">
                    <input
                      type="radio"
                      name="theme"
                      value="black"
                      checked={theme === "black"}
                      onChange={handleThemeChange}
                    />
                    <i></i>
                  </label>
                </div>
              </div>
            </div>

            {/* Signature Box */}
            <div className="signature-box">
              <div className="logo">
                <span className="svg-logo">
                  {/* Brand-consistent: use the company logo from company
                      information when set, else the built-in EM logo. */}
                  <img
                    src={brand?.company_logo ? `${UPLOAD_URL}${brand.company_logo}` : emlogo}
                    alt={brand?.company_name || "Company logo"}
                    style={{ width: 120, maxHeight: 56, objectFit: "contain" }}
                  />
                </span>
              </div>

              <div className="sign-details">
                <h3>{signature.name}</h3>
                <h4>{signature.designation}</h4>
                <div className="phone">
                  <i></i>
                  {signature.phone}
                </div>
                <div className="web">
                  <i></i>
                  {signature.website}
                </div>
              </div>
            </div>

            {/* Edit & Download Buttons */}

            <div className="edit-save">
              <Link to={`${basePath}/signature`} className="cancel-btn">
                Cancel
              </Link>
              <Link
                to={`${basePath}/signature/${signature.id}/edit`}
                className="edit-btn"
              >
                Edit
              </Link>

              <a
                className="save-btn"
                href={`${API_URL}/api/signatures/${signature.id}/download`}
                download={`signature_${signature.id}.png`}
              >
                Save as image
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewSignature;
